export default "__VITE_ASSET__622c8c42__"